module.exports = __webpack_public_path__ + "media/images/pic/authors/agata-krukowska-4656703c05932cadaa02d4d0eae539eb.png";